import NavBar from '../../components/NavBar';
import {
    ActivityIndicator,
    Animated,
    Easing,
    FlatList,
    Image,
    NativeScrollEvent,
    NativeSyntheticEvent,
    Platform,
    Pressable,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
    ViewToken,
} from 'react-native';
import { ChartMessageItem, ChatType, MessageAuditStatus, MessageMaskType, MessageType } from '../../constants/types';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import * as ImSdk from '../../../imsdk/api';
import { TopicWithSummary } from '../../../imsdk/api/topic';
import { buildSignalTopicId, isGroupTopic } from '../../utils/utils';
import { User } from '../../../imsdk/db/t_user';
import { UserSchema } from '../../realm/contactSchema';
import { MQEventCallBack } from '../../../imsdk/api/mq';
import { MessageSchema } from '../../realm/schema';
import { useStore } from '../../store/UserStore';
import { ActiveIcon, ChatInput, ChatPropsEvent, ForwardHandle } from './ChatInput';
import { chatStyles } from './styles';
import ChatViewItemRender from './ChatViewItemRender';
import { useIsFocused } from '@react-navigation/native';
import { getLastSendMsg, setLastSendMsg } from '../../net/database';
import time from '../../../imsdk/time';
import { showToast } from '../../components/Toast';
import { MainNavProps } from '../navigation/main/MainParamList';
import { getUserName } from './chat-helper';
import {
    bridgeOnePageIfNeeded,
    checkMsg,
    fix_msgs_time_all,
    fix_msgs_user1,
    GetHistoryMsg,
    GetJoinGroupList,
    loadLocalMsgsFromMsg,
    loadMsg,
    loadNewMsg,
    updateDetail,
    upsetMsg,
    useChatStore,
} from '../../store/ChatStore';
import { CryptEngine } from '../../utils/CryptEngine';
import { getEncrypt } from '../../store/token';
import { color_333333, color_666666, color_main, ColorF5F5F5, white } from '../../assets/style/colors';
import { ImagePreviewModal, PreviewItem } from '../../components/ImagePreviewModal';
import { groupBlackList, report, sendMsg } from '../../net/service';
import { SendMsgRequestData } from '../../net/request';
import {
    Str_InProhibition,
    Str_NewInvitationJoinGroup,
    Str_SendFail,
    Str_SpeakFrequently,
    Str_GroupChat,
    Str_GroupChatHistory,
    Str_And,
    Str_OfChatRecord,
    Str_Notice,
    Str_DelFail,
    Str_NewMsgCount,
    Str_NotInGroup_NotSend,
    Str_No_images,
    Str_No_videos,
    Str_CanNoFindMsg,
    Str_No_documents,
} from "../../language/string_res";
import { QuoteText } from "./QuoteText";
import { SelectDom } from "./SelectDom";
import TextTicker from "react-native-text-ticker";
import { CurTid } from "./ChatScreen";
import { postJson } from "../../net/http";
import { hideLoading, showLoading } from "../../components/Loading";
import { simple_search } from "../../utils/search";
import globalEventBus from "../../utils/EventBus";
import { ButtonView } from "../../components/ButtonView";
import { PickerResult } from "../../utils/PicOrCameraManager";
import { uploadProgressFile } from "../../utils/uploadImage";
// import { MediaManager } from "../../utils/MediaManager";
import { SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context";
import { GroupMember } from "../../../imsdk/db/t_group_member";
import { ImageView } from "../../components/ImageView";
import MoreIcon from "../../assets/svg/icon_more.svg";
import { RTCEngine } from "../../utils/RTCEngine";
import { Meta, Msg } from "../../../imsdk/db/t_msg";
import { useWindowDimensions } from 'react-native';
import VoicePlayManager from '../../utils/VoicePlayManager';
import { ChatDetail } from './ChatDetail';

async function topicName(topic: TopicWithSummary, currentUid: number) {
    let defaultName: string = "";
    if (isGroupTopic(topic.topic.tid)) {
        return findTopicName(topic, currentUid);
    } else {
        let user = topic.users?.find((v) => v.uid != currentUid);
        if (!user) {
            const r = await ImSdk.getInstance().GetUserMuti([topic.topic.uid]);
            if (r.users && r.users.length > 0) {
                user = r.users[0];
            }
        }
        if (user) {
            defaultName = getUserName(user);
        }
    }
    return defaultName;
}

function findTopicName(topic: TopicWithSummary, uid: number) {
    if (isGroupTopic(topic.topic.tid)) {
        return topic.group?.remark || topic.group?.name || topic.topic?.name || Str_GroupChat;
    }
    const users = topic.users?.filter((v) => v.uid !== uid);
    let name = "";
    if (users && users.length > 0 && users[0]) {
        const userName = getUserName(users[0]);
        name = userName || "";
    }
    return topic.topic.name || name || "";
}

const equals = (s1?: string, s2?: string): boolean => {
    if (!s1) {
        s1 = "";
    }
    if (!s2) {
        s2 = "";
    }
    return s1 === s2;
};
type ChatListState = {
    titleName: string;
    talkSelectStatus: boolean;
    unreadCnt: number;
};

let sendTime = 0;
export const ChatList = ({ navigation, route }: MainNavProps<"ChatList">) => {
    const { height: screenHeight } = useWindowDimensions();
    const insets = useSafeAreaInsets();
    const { state, dispatch } = useStore();
    const { chatState, chatDispatch } = useChatStore();
    const { isAdmin, cleanTid, joinGroupUsers, groupNotice, groupNoticeRead } = chatState;
    const im = ImSdk.getInstance();
    const currentUid = im.CurrentUid(); // 当前用户
    const topicSummary = chatState.curTopicWithSummary;
    // 添加侧边栏视图状态管理
    const [sidebarView, setSidebarView] = useState<'detail' | 'groupManager'>('detail');

    // 添加空值检查，防止 topicSummary 或 topicSummary.topic 为 undefined
    if (!topicSummary || !topicSummary.topic || !topicSummary.topic.tid) {
        return (
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: white }}>
                <Text style={{ color: color_666666 }}>加载中...</Text>
            </View>
        );
    }

    const group = topicSummary.group;
    const curTid = topicSummary.topic.tid;
    const isGroupChat = isGroupTopic(curTid);
    // 群主/管理员不受成员发图发视频发文件开关限制
    const canBypassMediaPermission =
        isGroupChat &&
        (chatState.adminSet?.has(currentUid) === true || group?.uid === currentUid || isAdmin === true);
    const canSendImage = !isGroupChat || canBypassMediaPermission || group?.group_member_image === "1";
    const canSendVideo = !isGroupChat || canBypassMediaPermission || group?.group_member_video === "1";
    const canSendFile = !isGroupChat || canBypassMediaPermission || group?.group_member_doc === "1";
    const curTidRef = useRef(curTid);
    curTidRef.current = curTid;

    /** 与当前详情 tid 对齐，避免 StrictMode/卸载瞬间 CurTid 为空导致 App 里 clearUnreadIfCurrentTopic 失效、总未读不落 */
    useLayoutEffect(() => {
        CurTid.tid = curTid;
    }, [curTid]);

    // 使用 useMemo 确保 titleName 在 topicSummary 变化时更新
    const initialTitleName = useMemo(() => {
        return findTopicName(topicSummary, currentUid);
    }, [topicSummary.topic.tid, topicSummary.topic.name, topicSummary.topic.remark, topicSummary.users]);

    const [data, setState] = useState<ChatListState>({
        titleName: initialTitleName,
        talkSelectStatus: false,
        unreadCnt: topicSummary.summary?.unreadCnt ?? 0,
    });

    // 当 topicSummary 变化时，更新状态
    const flatListRef = useRef<FlatList>(null);
    const isFocused = useIsFocused();
    const msg_cache_key = `${curTid}_latest_msgs`;
    const [selectItems, setselectItems] = useState<ChartMessageItem[]>([]);
    const [quote, setQuote] = useState<(MessageSchema & { user: UserSchema }) | undefined>(undefined);
    const messageListRef = useRef<ChartMessageItem[]>();
    const [dataVersion, setDataVersion] = useState(0);
    const [canSpeak, setCanSpeak] = useState(true); //被禁言
    const [isBanned, setBanned] = useState(true); ///全员禁言
    const [memberSyncing, setMemberSyncing] = useState(false);
    const [memberSyncError, setMemberSyncError] = useState<string | null>(null);
    // 图片预览相关状态
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewItems, setPreviewItems] = useState<PreviewItem[]>([]);
    const [initialPreviewIndex, setInitialPreviewIndex] = useState(0);
    const dataVersionRef = useRef(dataVersion);
    const isLoad = useRef<boolean>(false);
    const isTouch = useRef<boolean>(false);
    const oldUsers = useRef(chatState.curTopicWithSummary?.users);
    //退出群的成员
    const logoutUsers = useRef<{ [uid: number]: GroupMember | User }>({});
    const seenMids = useRef<Set<string>>(new Set());
    /** reportLatestReader2：同一 tid+mid 只打一次 SetTopicProps（含 mid>lsMid 与 mid===lsMid） */
    const equalLsMidReportedRef = useRef<string>("");
    const [isBottomSafeAreaShow, setBottomSafeAreaShow] = useState(false);
    const isBottomReached = useRef(false);

    // 侧边栏状态（Web 环境）
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const sidebarAnimation = useRef(new Animated.Value(0)).current;
    const isGroup = isGroupTopic(curTid);

    useEffect(() => {
        const handleCloseChatPanel = (payload: { tid: string }) => {
            if (curTid === payload.tid) {
                CurTid.tid = "";
                chatDispatch({ type: "CHAT_CLEAN" });
            }
        };
        globalEventBus.on("CloseChatPanel", handleCloseChatPanel);
        return () => {
            globalEventBus.off("CloseChatPanel", handleCloseChatPanel);
        };
    }, [curTid]);

    // 监听会话切换事件，如果侧边栏打开则先关闭
    useEffect(() => {
        if (Platform.OS !== 'web') {
            return;
        }

        const handleShowWebDetail = (data: any) => {
            // 如果侧边栏是打开的，且是切换到聊天列表，先关闭侧边栏
            if (isSidebarVisible && data.screenName === 'ChatList') {
                toggleSidebar(false);
            }
        };

        globalEventBus.on("ShowWebDetail", handleShowWebDetail);

        return () => {
            globalEventBus.off("ShowWebDetail", handleShowWebDetail);
        };
    }, [isSidebarVisible, Platform.OS]);
    // 当前列表中的最后一条消息
    const lastMsg = useRef<MessageSchema | undefined>(undefined);
    // 记录内容高度与偏移，用于“加载更多时保持视图不动”
    const scrollOffsetRef = useRef<number>(0);
    // 定位用到的控制变量 - start
    const canRemoveToMsgRef = useRef<MessageSchema | undefined>(undefined);
    const isNeedLocalAtTop = useRef(false);
    // 开始定位前.当前列表中的最后一条消息 - 用于判断是否已经加载完成了所有的消息
    const lastMsgWhileLical = useRef<MessageSchema | undefined>(undefined);
    const nextPageMsgs = useRef<MessageSchema[]>([])
    // 定位用到的控制变量 - end

    useEffect(() => {
        // 在三栏布局中，不依赖 isFocused，直接根据 topic 变化来加载数据
        if (topicSummary && topicSummary.topic && topicSummary.topic.tid) {
            equalLsMidReportedRef.current = "";
            // 切换话题时，重置输入框和相关状态
            setInputVal("");
            setQuote(undefined);

            setState(prev => ({
                ...prev,
                talkSelectStatus: false,
                unreadCnt: topicSummary.summary?.unreadCnt ?? 0,
            }));

            setselectItems([]);
            topicName(topicSummary, currentUid).then((name) => {
                setState(prev => ({
                    ...prev,
                    titleName: name,
                }));
            });
            groupBlack(topicSummary.topic.tid);
        }
        return () => {
            VoicePlayManager.stop()
        }
    }, [topicSummary?.topic?.tid]);

    function groupBlack(tid: string) {
        if (!isGroupTopic(tid)) {
            return;
        }
        groupBlackList({ tid }).then((r) => {
            if (r.data && r.data.members.length > 0) {
                const find = r.data.members.find((v) => v === currentUid);
                if (find) {
                    //黑名单
                    setCanSpeak(false);
                } else {
                    setCanSpeak(true);
                }
            }
        });
    }

    useEffect(() => {
        topicName(topicSummary, currentUid).then((name) => {
            setState({
                ...data,
                titleName: name,
            });
        });
        const groupBanChat = isGroupTopic(curTid) && !isAdmin && chatState?.curTopicWithSummary?.group?.group_ban_chat === "1";
        setBanned(!groupBanChat);
    }, [group, topicSummary.topic]);

    useEffect(() => {
        globalEventBus.on("SEND_MSG", handleEvent);
        return () => {
            globalEventBus.off("SEND_MSG", handleEvent);
            // 仅当全局当前会话仍是本会话时才清空，避免切会话时旧实例卸载把 CurTid 清掉，导致 topic_visit 回调里无法对齐未读
            const refTid = curTidRef.current;
            const willClearCurTid = CurTid.tid === refTid;
            if (willClearCurTid) {
                CurTid.tid = "";
            }
            chatDispatch({ type: "CHAT_CLEAN" });
        };
    }, []);

    const { messageList, isLastMsgNoShow } = useMemo(() => {
        const isNotShow = lastMsgWhileLical.current !== undefined && lastMsgWhileLical.current !== undefined && lastMsgWhileLical.current.mid > (lastMsg.current?.mid ?? "")
        dataVersionRef.current = dataVersion;
        const msgs = (messageListRef.current || []).filter(v => v.visible !== MessageAuditStatus.GONE && v.mask !== MessageMaskType.DELETED && v.tid === curTid);
        return { messageList: msgs, isLastMsgNoShow: isNotShow };
    }, [dataVersion]);

    useEffect(() => {
        const changeUser: (User | GroupMember)[] = [];
        oldUsers.current?.forEach((oldUser) => {
            chatState.curTopicWithSummary?.users?.forEach((newUser) => {
                if (oldUser.uid === newUser.uid) {
                    if (
                        !equals(oldUser.avatar, newUser.avatar) ||
                        !equals(oldUser.remark, newUser.remark) ||
                        !equals(oldUser.nick, newUser.nick) ||
                        !equals(oldUser.name, newUser.name)
                    ) {
                        changeUser.push(newUser);
                    }
                }
            });
        });
        if (changeUser.length > 0) {
            const list = (messageListRef.current || []).filter((v) => {
                const index = changeUser.findIndex((u) => v.sender == u.uid);
                if (index !== -1) {
                    v.user = changeUser[index];
                }
                return v;
            });
            setMessage(list, 13);
        }
        oldUsers.current = chatState.curTopicWithSummary?.users;
    }, [chatState.curTopicWithSummary?.users]);

    useEffect(() => {
        // 确保 topic 有效后再加载消息
        if (topicSummary && topicSummary.topic && topicSummary.topic.tid) {
            loadLastMsg(topicSummary);
        }
    }, [topicSummary?.topic?.tid]);

    function loadLastMsg(topicSummary: TopicWithSummary) {
        loadMsg(topicSummary)
            .then((r) => {
                setMessage(r, 1);
                if (data.unreadCnt > r.length) {
                    getHistoryMsg(r, data.unreadCnt);
                }
                const length = r.filter(v => v.visible === MessageAuditStatus.GONE).length;
                if (length > 10) {
                    isLoad.current = true;
                    checkMsg(topicSummary.topic.tid, r, 0).then(r => {
                        isLoad.current = false;
                        setMessage(r, 16);
                    })
                } else {

                }
            })
    }

    useEffect(() => {
        if (quote) {
            setTimeout(() => {
                chatInputRef?.current?.focus();
            }, 500);
        }
    }, [quote]);

    useEffect(() => {
        if (curTid === cleanTid) {
            setMessage([], 2);
        }
    }, [cleanTid, chatState.dataVersion]);

    useEffect(() => {
        // 如果转发成功提示展示则3s后关闭
        if (state?.forwardSuccTip) {
            handleForwardTip();
        }
    }, [state?.forwardSuccTip]);

    useEffect(() => {
        reportLatestReader2();
    }, [topicSummary, messageList, data.unreadCnt]);

    const reportLatestReader2 = () => {
        const n = messageList.length;
        let mid = "";
        let tid: string | undefined;
        const lsMid = topicSummary?.topic?.lsMid ?? "";
        for (let i = 0; i < n; i++) {
            const row = messageList[i];
            if (row.type === MessageType.LOCAL_TIME) {
                continue;
            }
            if (!row.mid || row.mid.length === 0) {
                continue;
            }
            if (row.mid > mid) {
                mid = row.mid;
                tid = row.tid || curTid;
            }
        }
        const effectiveTid = tid || curTid;

        if (!effectiveTid || effectiveTid !== curTid || !mid) {
            return;
        }
        if (!mid.startsWith(effectiveTid)) {
            return;
        }

        const strictlyNewer = mid > lsMid;
        // 列表最大 mid 已与 topic.lsMid 对齐（含「仍有未读」与「未读已被列表乐观清零」）：都要走 SetTopicProps/topic_visit，否则只清 UI 时 equalWithUnread 永远不成立
        const atLatestInList =
            lsMid.length > 0 && mid === lsMid && !strictlyNewer;

        if (!strictlyNewer && !atLatestInList) {
            return;
        }

        // midGtLsMid 与 atLatestInList 共用去重：同一 tid+mid 在一次挂载/会话内只打一次 SetTopicProps（避免 deps 连触发两次）
        const dedupeKey = `${effectiveTid}\0${mid}`;
        if (equalLsMidReportedRef.current === dedupeKey) {
            return;
        }
        equalLsMidReportedRef.current = dedupeKey;

        im.SetTopicProps({
            tid: effectiveTid,
            lsMid: mid,
        }).then((res) => {
            if (res.error) {
                equalLsMidReportedRef.current = "";
            }
        });
    };
    function reportTrack(body: any) {
        report(body);
    }
    function handleEvent(msg: ChartMessageItem) {
        const list = messageListRef.current ?? [];
        const index = list.findIndex((v) => {
            if (v.mid && v.mid.length > 0 && msg.mid && msg.mid.length > 0) {
                return v.mid === msg.mid;  // 都有 mid，通过 mid 匹配
            }
            return v.tid === msg.tid && v.cid === msg.cid && v.sender === msg.sender;
            // return (v.mid.length > 0 && v.mid === msg.mid) || (v.cid === msg.cid && v.sender === msg.sender);
        });

        // 1: 发送失败
        if (msg.send_statue === "1") {
            //查询数据库中是否存在这条数据，如果不存在则不插入
            im.QrySendingMsg(msg.tid, msg.cid, msg.sender).then((r) => {
                if (r.msgs && r.msgs.length > 0) {
                    if (index >= 0) {
                        list[index] = msg;
                        // 检查是否需要插入时间
                        // const fixList = fix_msgs_time_all(list);
                        setMessage(list, 3);
                    } else {
                        // const fixList = fix_msgs_time_all([msg, ...list]);
                        setMessage([msg, ...list], 4);
                    }
                } else {
                    if (index >= 0) {
                        list[index] = msg;
                        // const fixList = fix_msgs_time_all(list);
                        setMessage(list, 5);
                    } else {
                        // const fixList = fix_msgs_time_all([msg, ...list]);
                        setMessage([msg, ...list], 6);
                    }
                }
            });
        } else {
            if (index >= 0) {
                list[index] = msg;
                // const fixList = fix_msgs_time_all(list);
                setMessage(list, 7);
            } else {
                // 检查是否需要插入时间
                // const fixList = fix_msgs_time_all([msg, ...list]);
                setMessage([msg, ...list], 8);
            }
        }
        // 最后提条消息没有显示,说明在定位, 不需要滚动到底部
        if (isLastMsgNoShow) {
            return;
        }
        // 滚动到底部
        scrollToFront(true, false);
    }

    const updateMsg = (tid: string, mid: string) => {
        const curMessageLists = messageListRef.current ?? []
        const idx = simple_search<ChartMessageItem>(curMessageLists, (a): number => {
            if (a.mid === mid) return 0;
            return a.mid > mid ? 1 : -1;
        });
        if (idx >= 0) {
            ImSdk.getInstance()
                .GetMsg({ tid, mid })
                .then((r1) => {
                    if (r1.msgs && r1.msgs.length > 0) {
                        const m = r1.msgs[0] as ChartMessageItem;
                        curMessageLists[idx] = m;
                        if (m.mask === MessageMaskType.DELETED) {
                            ImSdk.getInstance()
                                .DelMsg(m.tid, [{ mid: m.mid, cid: m.cid }])
                                .then();
                            // 删除目标消息
                            curMessageLists.splice(idx, 1);
                            // 仅在删除点附近做局部时间线清理，避免整表遍历
                            const tryRemoveTimelineAt = (list: ChartMessageItem[], i: number) => {
                                if (i < 0 || i >= list.length) return;
                                const item = list[i];
                                if (item.type !== MessageType.LOCAL_TIME) return;
                                // UI 底部时间线直接移除（数组 index 0）
                                if (i === 0) {
                                    list.splice(i, 1);
                                    return;
                                }
                                // 保留 UI 顶部时间线（数组最后一项）
                                if (i === list.length - 1) {
                                    return;
                                }
                                const prev = list[i + 1];
                                const next = list[i - 1];
                                const prevIsMsg = !!prev && prev.type !== MessageType.LOCAL_TIME;
                                const nextIsMsg = !!next && next.type !== MessageType.LOCAL_TIME;
                                // 若成为孤立时间线（两侧都无正常消息），移除
                                if (!prevIsMsg && !nextIsMsg) {
                                    list.splice(i, 1);
                                }
                            };
                            // 检查删除点两侧的时间线
                            tryRemoveTimelineAt(curMessageLists, idx); // 删除元素后落在该位置的元素
                            tryRemoveTimelineAt(curMessageLists, idx - 1); // 删除元素前一个位置

                            // 如果列表里已经没有任何真实消息，则移除所有时间线，保持列表为空
                            const hasRealMsg = curMessageLists.some((v) => v.type !== MessageType.LOCAL_TIME);
                            if (!hasRealMsg) {
                                for (let i = curMessageLists.length - 1; i >= 0; i--) {
                                    if (curMessageLists[i].type === MessageType.LOCAL_TIME) {
                                        curMessageLists.splice(i, 1);
                                    }
                                }
                            }
                        }

                        setMessage([...curMessageLists], 9);
                    }
                });
        }
    };

    const imcallback: MQEventCallBack = async (res) => {
        // 用户信息变化了，更新消息
        // 会话信息变了，更新标题
        // 群信息变了，更新admin
        // 来新消息了，只要不是本会话忽略，是本会话添加消息
        if (res.type === "msg_update") {
            if (res.data.msg_update) {
                const { tid, mid } = res.data.msg_update;
                if (tid !== curTid) {
                    return;
                }
                updateMsg(tid, mid);
            }
        } else if (res.type === "msg_new") {
            if (res.data.msg_new) {
                if (isLastMsgNoShow) {
                    return;
                }
                const tid = res.data.msg_new.tid;
                if (tid === curTid) {
                    loadNewMsg(curTid, messageListRef.current ?? messageList).then((r) => {
                        setMessage(r, 10);
                    });
                }
            }
        } else if (res.type === "userinfo") {
            // 如果现在是单聊，修改下会话标题
            // 同时在消息里找下涉及的用户，修改消息的user信息
            if (res.data.userinfo) {
                if (messageList && messageList.length > 0) {
                    const n = messageList.length;
                    let hasChange = false;
                    for (let i = 0; i < n; i++) {
                        if (messageList[i].sender === res.data.userinfo.uid) {
                            hasChange = true;
                            messageList[i].user = res.data.userinfo as any as UserSchema;
                        }
                    }
                    if (hasChange) {
                        im.SetCache(msg_cache_key, messageList);
                    }
                }
            }
        } else if (res.type === "group_update") {
            const tid = res.data.group_update?.tid || "";
            updateChatDetail();
        } else if (res.type === "topic_remark") {
            const tid = res.data.topic_remark?.tid || "";
            if (tid === curTid) {
                const remark = res.data.topic_remark?.remark ?? "";
                chatDispatch({ type: "CHAT_UPDATE_REMARK", payload: remark });
            }
        } else if (res.type === "user_remark") {
            const tid = buildSignalTopicId(res.data.user_remark?.uid || 0, currentUid);
            if (tid === curTid) {
                updateChatDetail();
            }
        } else if (res.type === "group_apply") {
            const tid = res.data.group_apply?.tid || "";
            if (tid === curTid) {
                GetJoinGroupList(chatState, chatDispatch);
            }
        } else if (res.type === "topic_update") {
            updateChatDetail();
        } else if (res.type === "group_black") {
            if (res.data.group_black?.tid === curTid) {
                groupBlack(curTid);
            }
        } else if (res.type === "msg_read") {
            const { tid, mid, readCnt, targetCnt, msg } = res.data.msg_read || {};
            if (tid !== curTid) return;
            if (!mid) return;
            if (msg) {
                ImSdk.getInstance().UpsetMsg(currentUid, msg);
            } else {
                // 手动更新本地那条消息的 readCnt
                const idx = messageListRef.current?.findIndex((m) => m.mid === mid) ?? 0;
                if (idx >= 0) {
                    const list = [...(messageListRef.current ?? [])];
                    list[idx] = { ...list[idx], readCnt, targetCnt };
                    messageListRef.current = list;
                    setDataVersion((v) => v + 1); // 强制刷新 UI
                }
            }
        }
    };

    function updateChatDetail() {
        updateDetail(chatState, chatDispatch);
    }

    useEffect(() => {
        im.on("userinfo", imcallback);
        im.on("group_update", imcallback);
        im.on("topic_update", imcallback);
        im.on("user_remark", imcallback);
        im.on("msg_new", imcallback);
        im.on("msg_update", imcallback);
        im.on("topic_remark", imcallback);
        im.on("group_apply", imcallback);
        im.on("msg_read", imcallback);
        im.on("group_black", imcallback);
        return () => {
            im.off("*", imcallback);
        };
    }, [topicSummary?.topic?.tid, curTid]);

    // 进入群聊时若成员尚未同步，同步拉取并展示全屏 loading；失败时展示错误+重试
    const syncGroupMembers = useCallback(async (tid: string) => {
        setMemberSyncing(true);
        setMemberSyncError(null);
        try {
            const r = await im.GetGroupDetail(tid, true);
            if (r.error) {
                setMemberSyncError(String(r.error));
            } else {
                // sync=true 路径不会 emit group_update，手动刷新 UI 状态
                updateDetail(chatState, chatDispatch);
            }
        } catch (e: any) {
            setMemberSyncError(e?.message ?? "加载失败，请重试");
        } finally {
            setMemberSyncing(false);
        }
    }, [chatState, chatDispatch]);

    useEffect(() => {
        if (topicSummary?.topic?.type === "group" && curTid) {
            if (group?.member_synced !== 1) {
                // 成员未同步，全屏 loading 拉取
                syncGroupMembers(curTid);
            } else {
                // 已同步，直接刷新 UI 保证 prop 和 context 一致
                setMemberSyncing(false);
                setMemberSyncError(null);
                updateDetail(chatState, chatDispatch);
            }
        } else {
            setMemberSyncing(false);
            setMemberSyncError(null);
        }
    }, [curTid]);

    useEffect(() => {
        if (!messageListRef.current || messageListRef.current.length === 0) return;

        const im = ImSdk.getInstance();
        const uid = im.CurrentUid();
        const mids = messageListRef.current
            .filter((m) => m.sender !== uid && m.mid?.length > 0)
            .map((m) => ({ mid: m.mid, sender: m.sender }));

        if (mids.length > 0) {
            im.MsgRead(mids).catch(() => { });
        }
    }, [topicSummary.topic.tid]);

    const chatInputRef = useRef<ForwardHandle>(null);
    const [inputVal, setInputVal] = useState("");

    function scrollToUnread() {
        if (data.unreadCnt > -1 && data.unreadCnt < messageList.length) {
            const msg = messageList[data.unreadCnt]
            flatListRef.current?.scrollToItem({
                item: msg,
                viewPosition: 1,
            });
            setState({ ...data, unreadCnt: 0 });
        }
    }

    function handleForwardTip() {
        setTimeout(() => {
            clearForwardTip();
        }, 2000);
    }

    function clearForwardTip() {
        dispatch({ type: "UPDATE_FORWARD_TIP_STATUS", payload: false });
    }

    function getHistoryMsg(msgs: ChartMessageItem[] = [], limit: number = 100) {
        const list = msgs.length > 0 ? msgs : (messageListRef.current ?? []);
        if (list.length > 0 && !(isLoad.current && isLoad.current)) {
            isLoad.current = true;
            GetHistoryMsg(curTid, list, limit).then((r) => {
                if (r.length) {
                    setMessage(r, 11);
                }
            }).finally(() => {
                isLoad.current = false;
            });
        }
    }

    const checkInGroup = () => {
        const uid = ImSdk.getInstance().CurrentUid();
        // 与标题成员数保持一致，使用同一个 topicSummary.users（prop）避免 prop 与 context 时序不一致导致误判
        const users = topicSummary?.users?.map((v) => v.uid) || [];
        // 同步中或未同步完成时不以本地数据判断（服务端负责兜底校验）
        if (memberSyncing || group?.member_synced !== 1) return true;
        if (users.length === 0) return true;
        return users.includes(uid);
    };
    async function checkSend(): Promise<boolean> {
        if (!curTid) return false;
        const b = checkInGroup();
        if (topicSummary.topic.type === "group" && !b) {
            showToast(Str_NotInGroup_NotSend);
            return false;
        }
        let lastSendTime = 0;
        let canSend = true;
        if (topicSummary.topic.type == "group" && !isAdmin) {
            const lastSendMsg = await getLastSendMsg(topicSummary.topic.uid, curTid);
            if (lastSendMsg && lastSendMsg.length > 0) {
                lastSendTime = lastSendMsg[0].time;
            }

            //全体禁言
            if (chatState?.curTopicWithSummary?.group?.group_ban_chat === "1") {
                showToast(Str_InProhibition);
                canSend = false;
            } else if (group?.group_chat_interval_time) {
                //发言间隔时间校验
                const num = Number(group.group_chat_interval_time) * 1000;
                const nowTime = time.now().getTime();

                if (lastSendTime + num > nowTime) {
                    showToast(Str_SpeakFrequently);
                    canSend = false;
                }
            }
        }
        return canSend;
    }

    function trimEndTwoSpaces(str: string): string {
        // 使用正则表达式匹配末尾的空白字符（空格或换行符）
        return str.replace(/[\s\n]{1,2}$/, "");
    }

    const handleSubmitMsg = async (e: ChatPropsEvent) => {
        if (!(await checkSend())) return;
        let cid = Date.now();
        //防止短时间内消息重复
        if (cid === sendTime) {
            cid += 100;
        }
        sendTime = cid;
        let content = trimEndTwoSpaces(e.content);
        let encrypt = getEncrypt();
        let user: UserSchema = { uid: currentUid };
        if (state && state.user) {
            user = state?.user;
        }
        // 只对文件类消息补全 meta 字段
        const sourceMeta = (e.meta || {}) as Record<string, any>;
        let meta: any = sourceMeta;
        if (e.type === MessageType.IMAGE || e.type === MessageType.VIDEO || e.type === MessageType.DOCUMENT) {
            meta = {
                fileName: sourceMeta.fileName || sourceMeta.name || sourceMeta.filename || '未知文件',
                fileSize: (sourceMeta.fileSize ?? sourceMeta.size ?? 0).toString(),
                mimeType: sourceMeta.mimeType || sourceMeta.mime_type || '',
                ...sourceMeta
            };
        }
        const msg: ChartMessageItem = {
            tid: curTid,
            cid: cid,
            type: e.type,
            content: content,
            atUids: e.atUids,
            encrypt: encrypt,
            meta,
            mid: "",
            sender: currentUid,
            send_statue: "0",
            user: user,
            targetCnt: Math.max(0, (chatState.curTopicWithSummary?.users?.length ?? 1) - 1),
            stime: time.now().getTime(),
        };

        handleEvent(msg);

        const bodyMeta = (e.meta || {}) as any
        // 剔除本地资源路径
        if (e.type == MessageType.IMAGE || e.type == MessageType.VIDEO || e.type == MessageType.VOICE) {
            bodyMeta['upload_path'] = ''
            bodyMeta['thumbnail'] = ''
        }
        content = CryptEngine.encode(encrypt, content, cid);
        const body: SendMsgRequestData = {
            toTopidId: curTid,
            type: e.type,
            content: content,
            cid: cid.toString(),
            atUids: e.atUids,
            encrypt: encrypt,
            meta: bodyMeta,
        };

        if (quote) {
            const duration = quote.type == MessageType.VOICE ? quote.meta?.duration || "1" : "";
            let thumbnail = "";
            if (quote.type == MessageType.VIDEO || quote.type == MessageType.IMAGE) {
                if (quote.thumbnailPath && quote.thumbnailPath?.startsWith("http")) {
                    thumbnail = quote.thumbnailPath;
                }
            }

            // 组装发给对方的消息中的引用信息
            const meta = {
                quoteMid: quote.mid,
                quoteTid: quote.tid,
                quoteUid: `${quote.sender}`,
                quoteUser: !isGroup ? getUserName(quote.user) : (quote.user?.nick || quote.user?.name || quote.user.employee),
                quoteCnt: quote.content || "",
                quoteType: quote.type,
                duration: duration,
                isQuoteSelf: quote.sender === currentUid ? "1" : "0", // 是否引用自己的消息
                thumbnail: thumbnail,
            };

            body.meta = meta;

            // console.log('---> quote', quote);
            // console.log('---> meta', meta);

            // 组装本地显示的消息
            msg.meta = meta;
            // 可能存在本地图片
            if (quote.type == MessageType.IMAGE || quote.type == MessageType.VIDEO || quote.type == MessageType.DOCUMENT) {
                if (quote.upload_path?.length != 0) {
                    if ((quote.upload_path?.length ?? 0) > 0) {
                        msg.meta.upload_path = quote.upload_path;
                    }
                }

                if ((quote.thumbnailPath?.length ?? 0) > 0) {
                    msg.meta.thumbnail = quote.thumbnailPath;
                }
            }
        }

        await upsetMsg(msg);

        const res = await sendMsg(body);
        if (res.code !== 0) {
            sendFail(msg, res.msg);
        } else {
            await sendSuc(msg, res.data?.mid, res.data?.auditWord, res.data?.auditWordTip);
        }
        // }).catch(err => {
        //     sendFail(msg, err.msg)
        // })
    };

    function sendFail(failMsg: ChartMessageItem, errMsg?: string) {
        setQuote(undefined);
        failMsg.send_statue = "1";
        // 只兜底：如果是文件类消息且 meta 缺失，才补全
        if (failMsg && (failMsg.type === MessageType.IMAGE || failMsg.type === MessageType.VIDEO || failMsg.type === MessageType.DOCUMENT)) {
            const failMeta = (failMsg.meta || {}) as Record<string, any>;
            if (!failMeta.fileName) failMeta.fileName = failMeta.fileName || failMeta.name || failMeta.filename || '未知文件';
            if (!failMeta.fileSize) failMeta.fileSize = failMeta.fileSize || failMeta.size || '0';
            if (!failMeta.mimeType) failMeta.mimeType = failMeta.mimeType || failMeta.mime_type || '';
            failMsg.meta = failMeta as any;
        }
        // 日志详细输出
        if (typeof console !== 'undefined') {
            console.error('[BEE-FILE][SEND-FAIL]', {
                cid: failMsg.cid,
                type: failMsg.type,
                name: failMsg.meta?.name,
                size: failMsg.meta?.size,
                mimeType: failMsg.meta?.mimeType,
                errMsg,
                failMsg,
            });
        }
        upsetMsg(failMsg).then();
        showToast(errMsg || Str_SendFail);
        handleEvent(failMsg);
    }
    async function sendSuc(msg: ChartMessageItem, mid?: string, auditWord?: string, auditWordTip?: string) {
        msg.send_statue = "";
        msg.upload_statue = "";
        msg.mid = mid || "";
        if (auditWord && auditWordTip && auditWord.length > 0 && auditWordTip.length > 0) {
            msg.auditWord = auditWord;
            msg.auditWordTip = auditWordTip;
            msg.visible = MessageAuditStatus.INFO;
        }

        upsetMsg(msg).then();
        handleEvent(msg);
        setQuote(undefined);
        if (topicSummary.topic.type == "group") {
            await setLastSendMsg({ uid: topicSummary.topic.uid, tid: curTid, time: time.now().getTime() });
        }
    }

    const handleSubmitMedia = async (result: PickerResult[]) => {
        if (!(await checkSend())) return;
        let cid = Date.now();
        const encrypt = getEncrypt();
        let user: UserSchema = { uid: currentUid };
        if (state && state.user) {
            user = state?.user;
        }
        const length = result.length || 0;
        for (let i = 0; i < length; i++) {
            const item = result[i];
            //防止短时间内消息重复
            if (cid === sendTime) {
                cid += 100;
            }
            sendTime = cid;
            let type: MessageType;
            if (item.type === "doc") {
                type = MessageType.DOCUMENT;
            } else if (item.type === "photo" || (item.mimeType && item.mimeType.includes("octet-stream"))) {
                type = MessageType.IMAGE;
            } else {
                type = MessageType.VIDEO;
            }
            // Web 平台：path 可能是 data URL，不需要添加 file:// 前缀
            // 移动端：需要添加 file:// 前缀
            let filePath: string;
            if (Platform.OS === 'web') {
                // Web 平台：data URL 或网络 URL 直接使用
                filePath = item.path;
            } else {
                // 移动端：添加 file:// 前缀
                filePath = item.path.startsWith("file://") ? item.path : "file://" + item.path;
            }
            // 只对文件类消息补全 meta 字段
            let meta: any = {};
            if (type === MessageType.IMAGE || type === MessageType.VIDEO || type === MessageType.DOCUMENT) {
                meta = {
                    fileName: item.fileName || '未知文件',
                    fileSize: (item.fileSize ?? 0).toString(),
                    mimeType: item.mimeType || '',
                    width: (item.width ?? 0).toString(),
                    height: (item.height ?? 0).toString(),
                };
                if (item.thumbnailPath) meta.thumbnail = item.thumbnailPath;
            }

            const msg: ChartMessageItem = {
                tid: curTid,
                cid: cid,
                type: type,
                content: "",
                encrypt: encrypt,
                meta,
                mid: "",
                sender: currentUid,
                send_statue: "0",
                user: user,
                targetCnt: Math.max(0, (chatState.curTopicWithSummary?.users?.length ?? 1) - 1),
                stime: time.now().getTime(),
                upload_path: filePath,
                upload_statue: "0",
            };

            if (i === 0 && quote) {
                const duration = quote.type == MessageType.VOICE ? quote.meta?.duration || "1" : "";
                let thumbnail = "";
                if (quote.type == MessageType.VIDEO || quote.type == MessageType.IMAGE) {
                    if (quote.thumbnailPath && quote.thumbnailPath?.startsWith("http")) {
                        thumbnail = quote.thumbnailPath;
                    }
                }

                // 组装发给对方的消息中的引用信息
                const meta = {
                    quoteMid: quote.mid,
                    quoteTid: quote.tid,
                    quoteUid: `${quote.sender}`,
                    quoteUser: !isGroup ? getUserName(quote.user) : (quote.user?.nick || quote.user?.name || quote.user.employee),
                    quoteCnt: quote.content || "",
                    quoteType: quote.type,
                    duration: duration,
                    isQuoteSelf: quote.sender === currentUid ? "1" : "0", // 是否引用自己的消息
                    thumbnail: thumbnail,
                };

                // 组装本地显示的消息
                msg.meta = { ...msg.meta, ...meta };
                // 可能存在本地图片
                if (quote.type == MessageType.IMAGE || quote.type == MessageType.VIDEO || quote.type == MessageType.DOCUMENT) {
                    if (quote.upload_path?.length != 0) {
                        if ((quote.upload_path?.length ?? 0) > 0) {
                            msg.meta.upload_path = quote.upload_path;
                        }
                    }

                    if ((quote.thumbnailPath?.length ?? 0) > 0) {
                        msg.meta.thumbnail = quote.thumbnailPath;
                    }
                }
            }
            await sendMedia(msg, item);
        }
    };

    const handleItemClick = (item: MessageSchema) => {
        if (data.talkSelectStatus === true) {
            // 转发状态
            mutiForwardSelectItem(item);
        } else {
            if (item.type === MessageType.RTC_VIDEO || item.type === MessageType.RTC_VOICE) {
                callRTC(item.type === MessageType.RTC_VIDEO);
            } else if (item.type === MessageType.IMAGE || item.type === MessageType.VIDEO) {
                const mediaPreviewItems = messageListRef.current
                    ?.filter((it) => it.type === MessageType.IMAGE || it.type === MessageType.VIDEO)
                    .reverse();
                if (!mediaPreviewItems || mediaPreviewItems.length === 0) {
                    return;
                }

                let index = mediaPreviewItems.findIndex((it) => it.mid === item.mid);
                index = index < 0 ? 0 : index;

                // 使用 ImagePreviewModal 替代导航
                setPreviewItems(mediaPreviewItems as PreviewItem[]);
                setInitialPreviewIndex(index);
                setPreviewVisible(true);
            }
        }
    };

    async function sendMedia(msg: ChartMessageItem, item: PickerResult) {
        if (!isAdmin && isGroupTopic(curTid) && group) {
            const canImg = group.group_member_image === "1";
            const canVideo = group.group_member_video === "1";
            const canDoc = group.group_member_doc === "1";
            if (msg.type === MessageType.IMAGE && !canImg) {
                showToast(Str_No_images);
                return;
            }
            if (msg.type === MessageType.VIDEO && !canVideo) {
                showToast(Str_No_videos);
                return;
            }
            if (msg.type === MessageType.DOCUMENT && !canDoc) {
                showToast(Str_No_documents);
                return;
            }

        }

        handleEvent(msg);

        await upsetMsg(msg);
        const docSize = item.type === "doc" ? item.fileSize : undefined
        uploadProgressFile(item, currentUid, msg.cid.toString(), docSize).then(async (r) => {
            // 上传失败直接 return，并 toast 提示
            if (r.code !== 0 || !r.url) {
                msg.upload_statue = "1";
                msg.send_statue = "1";
                sendFail(msg, r.msg);
                if (typeof showToast === 'function') {
                    showToast(r.msg || '文件上传失败');
                }
                return;
            }

            // 上传成功，继续发消息
            let content = r.url;
            let c = r.cid;
            content = CryptEngine.encode(msg.encrypt ?? 0, r.url, c);
            const bodyMeta = (msg.meta || {}) as any;
            // 剔除本地资源路径
            if (msg.type == MessageType.IMAGE || msg.type == MessageType.VIDEO) {
                bodyMeta['upload_path'] = '';
                bodyMeta['thumbnail'] = '';
            }
            const body: SendMsgRequestData = {
                toTopidId: curTid,
                type: msg.type,
                content: content,
                cid: c,
                encrypt: msg.encrypt ?? 0,
                meta: msg.meta,
            };

            msg.content = r.url;
            msg.upload_statue = "";
            await upsetMsg(msg);
            handleEvent(msg);

            // 发送消息
            const res = await sendMsg(body);

            if (res.code !== 0) {
                sendFail(msg, res.msg);
            } else {
                await sendSuc(msg, res.data?.mid);
            }
        });
    }

    const handleQuote = useCallback((item: MessageSchema & { user: UserSchema }) => {
        setQuote(item);
    }, []);

    // 尝试在当前已有列表中查找
    function tryToFindQuoteMessageAndScrollToItem(msg: MessageSchema): boolean {
        const meta = msg.meta as Meta;
        const mid = meta.quoteMid;
        // 当前列表中存在, 直接滚动
        if (mid && messageListRef.current) {
            // 当前消息的下标
            const msgIdx = messageListRef.current.findIndex((it) => it.mid === msg.mid);
            // 需要定位到的消息的下标
            const index = messageListRef.current.findIndex((it) => it.mid === mid);
            // 大于100可能会有问题
            if (index >= 0) {
                // 两条消息位置差距小于100, 直接跳转
                if (Math.abs(index - msgIdx) <= 100) {
                    // 获取跳转位置的item
                    const item = messageListRef.current![index];
                    flatListRef.current?.scrollToItem({
                        item: item,
                        viewPosition: 1,
                        animated: Math.abs(msgIdx - index) < 10,
                        viewOffset: -10, // 顶部留有间距
                    });
                    // 跳转成功
                    return true;
                } else {
                    //从目的下标出截取15条, 因为是引用, 又因为是倒序的,所以 index只可能比msgIdx大, 而 index - msgIdx > 100, 所以index - 15都会大于0, 这里只是做容错
                    if (index - 15 >= 0) {
                        const msgs = messageListRef.current.splice(index - 15, 16)
                        // 标记需要定位在顶部
                        isNeedLocalAtTop.current = true;
                        // 标记分批的最后一条未未定义
                        lastMsg.current = undefined;
                        // 更新列表数据
                        setMessage(msgs, 14);
                        // 跳转成功
                        return true;
                    }
                }
            }
        }
        // 跳转失败
        return false;
    }

    // 尝试在数据库中查找并分页
    function tryToFindQuoteMessageIndexAndScrollToItem(msg: MessageSchema) {
        // 当前列表中没有,数据库前10000条也没有, 从数据库查找
        const meta = msg.meta as Meta;
        const mid = meta.quoteMid;
        const tid = meta.quoteTid;
        // 现有列表找不到 - 从数据库中查找
        ImSdk.getInstance()
            .GetMsg({ tid, mid })
            .then((res) => {
                if (res.msgs && res.msgs.length > 0) {
                    const msg: Msg = res.msgs[0];
                    // 标记需要定位在顶部
                    isNeedLocalAtTop.current = true;
                    // 标记分批的最后一条未未定义
                    lastMsg.current = undefined;
                    getHistoryMsgsFromMsg(msg as ChartMessageItem);
                } else {
                    // 本地数据库中找不到
                    showToast(Str_CanNoFindMsg);
                }
            })
            .catch((err) => {
                showToast(Str_CanNoFindMsg);
            });
    }

    const handleQuoteLocal = useCallback((msg: MessageSchema) => {
        if (isLoad.current) {
            return;
        }

        if (messageListRef.current && messageListRef.current.length > 0) {
            lastMsgWhileLical.current = messageListRef.current[0];
        }

        //第一重: 尝试在当前列表中查找
        if (tryToFindQuoteMessageAndScrollToItem(msg)) {
            return;
        }

        //第二重: 尝试拉取10000条历史消息并查找
        tryToFindQuoteMessageIndexAndScrollToItem(msg);
    }, []);

    const handleChangeMask = useCallback((item: MessageSchema, mask: MessageMaskType) => {
        // 会有位置变更，后续滚动条需要重置位置
        item.mask = mask;
        upsetMsg(item as ChartMessageItem)
    }, []);

    const delMsg = (item: ChartMessageItem) => {
        delMsgList([item]);
    };

    function delMsgList(selectItems: ChartMessageItem[]) {
        let newList = messageList.filter((v) => {
            const b = !selectItems.includes(v);
            return b;
        });
        // 局部清理：若无任何真实消息，移除全部时间线；否则移除底部与孤立时间线
        const hasRealMsg = newList.some((v) => v.type !== MessageType.LOCAL_TIME);
        if (!hasRealMsg) {
            newList = [];
        } else {
            // 移除底部(UI)时间线：数组第 0 项
            if (newList.length > 0 && newList[0].type === MessageType.LOCAL_TIME) {
                newList.splice(0, 1);
            }
            // 移除孤立时间线（两侧都不是正常消息）
            for (let i = newList.length - 2; i >= 1; i--) {
                const item = newList[i];
                if (item.type === MessageType.LOCAL_TIME) {
                    const prev = newList[i + 1];
                    const next = newList[i - 1];
                    const prevIsMsg = !!prev && prev.type !== MessageType.LOCAL_TIME;
                    const nextIsMsg = !!next && next.type !== MessageType.LOCAL_TIME;
                    if (!prevIsMsg && !nextIsMsg) {
                        newList.splice(i, 1);
                    }
                }
            }
        }
        setMessage(newList, 12);
    }

    function setMessage(msgs: ChartMessageItem[], triceId: number) {
        msgs = fix_msgs_time_all(msgs);

        if (triceId !== 1 && triceId !== 14 && isLastMsgNoShow) {
            return;
        }

        isTouch.current = false;
        fix_msgs_user1(chatState.curTopicWithSummary?.users || [], logoutUsers.current, msgs)
            .then((fix) => {
                messageListRef.current = fix.msgs;
                logoutUsers.current = fix.logoutUser;
                setDataVersion(dataVersionRef.current + 1);
                const curLastMsg = messageListRef.current[0];

                if (messageListRef.current && messageListRef.current.length > 0) {
                    if (triceId === 14) {
                        if (isNeedLocalAtTop.current) {
                            isLoad.current = false;
                            // 提前准备下一页的数据
                            prepareNextPageMsg(curLastMsg)
                        }
                    } else {
                        scrollToFront(false, triceId == 1);
                    }
                }

                const lastMsgInfo = msgs && msgs.length > 0 ? `mid:${msgs[0].mid}  content:${msgs[0].content.substring(0, 10)}` : "";
                if (triceId !== 10 && triceId !== 14) {
                    reportTrack({ "msg": `${curTid} triceId: ${triceId}-setMessage srcLength: ${msgs.length}-lastMsg:${lastMsgInfo}` });
                }
                const n = msgs.length;
                im.SetCache(msg_cache_key, msgs.slice(0, n > 100 ? 100 : n));
            })
            .catch(() => {
                if (triceId === 14) {
                    isBottomReached.current = false;
                    isLoad.current = false;
                }
            });
    }

    // 转发消息
    const sendMessage = async () => {
        const user = state?.user;
        if (!user) return;
        let title;
        if (isGroupTopic(curTid)) {
            title = Str_GroupChatHistory;
        } else {
            const users = selectItems.map((v) => v.user);
            const filter = users.filter((item, index) => users.indexOf(item) === index);
            if (filter.length === 2) {
                const name1 = filter[0]?.nick || filter[0]?.name || filter[0]?.remark || "";
                const name2 = filter[1]?.nick || filter[1]?.name || filter[1]?.remark || "";
                title = `${name1} ${Str_And} ${name2}${Str_OfChatRecord}`;
            } else if (filter.length === 1) {
                const name1 = filter[0]?.nick || filter[0]?.name || filter[0]?.remark || "";
                title = `${name1}${Str_OfChatRecord}`;
            }
        }

        // TODO 这里感觉还可以优化一波
        const newCurrentMessage: MessageSchema = {
            content: JSON.stringify({ title, selectMessages: selectItems }),
            type: MessageType.TALK,
            mid: "",
            tid: "",
            meta: {},
            cid: 0,
            stime: 0,
            send_statue: "",
            sender: user.uid,
        };
        setState({ ...data, talkSelectStatus: false });
        navigation.navigate("ForwardChat", { msg: newCurrentMessage });
    };

    async function handleDelete() {
        const mids: string[] = [];
        selectItems.forEach((v) => {
            if (v.mid.length > 0) {
                mids.push(v.mid);
            }
        });

        setState({ ...data, talkSelectStatus: false });
        showLoading();
        postJson("/v1/sdk/msg/local/delete", { body: { mids: mids, tid: curTid } }).then((r) => {
            if (r.code === 0) {
                ImSdk.getInstance()
                    .DelMsg(curTid, selectItems)
                    .then((r) => {
                        if (r.code >= 0) {
                            delMsgList(selectItems);
                            ImSdk.getInstance().emit("msg_del", { msg_del: { tid: curTid } });
                        }
                        hideLoading();
                    });
            } else {
                hideLoading();
                showToast(Str_DelFail);
            }
        });
    }

    // isForce: 是否强制  offset: 20为底部间距
    const scrollToFront = (animated = false, isForce: boolean = false) => {
        const offset = 0 //底部的间距
        // 往回查看消息, 超过一屏久不在滚回底部
        if (scrollOffsetRef.current >= screenHeight && !isForce) {
            return;
        }

        setTimeout(() => {
            flatListRef.current?.scrollToOffset({ animated: animated && (scrollOffsetRef.current <= 300), offset: offset });
        }, 200);
    };

    const onLongPressUserHead = useCallback(
        (user: User) => {
            chatInputRef.current?.addAtUser(user);
        },
        [chatInputRef]
    );

    function msgIsSelected(item: ChartMessageItem) {
        return selectItems.find((it) => item.mid === it.mid) != undefined;
    }

    // 多选转发选中
    function mutiForwardSelectItem(sitem: ChartMessageItem): void {
        if (sitem.type === MessageType.RTC_VIDEO || sitem.type === MessageType.RTC_VOICE || sitem.type === MessageType.LOCAL_TIME) {
            return;
        }

        const item = selectItems.find((v: ChartMessageItem) => {
            return v.mid === sitem.mid;
        });

        onSelectedItemChanged(sitem, item === undefined);
    }

    function onSelectedItemChanged(item: ChartMessageItem, isSelected: boolean) {
        if (!isSelected) {
            const newsSelectMessage: ChartMessageItem[] = selectItems.filter((v: ChartMessageItem) => {
                if (v.mid !== item.mid) {
                    return true;
                }
            });
            setselectItems(newsSelectMessage);
        } else {
            const newsSelectMessage: ChartMessageItem[] = [...selectItems, item].sort((a, b) => a.stime - b.stime);
            setselectItems(newsSelectMessage);
        }
    }

    // 上报已读
    const onViewableItemsChangedRef = useRef((info: any) => {
        const im = ImSdk.getInstance();
        const uid = im.CurrentUid();
        if (!info?.viewableItems?.length) return;

        const mids = info.viewableItems
            .map((v: ViewToken) => v.item)
            .filter((m: ChartMessageItem) => m.visible !== MessageAuditStatus.INFO && m.sender !== uid && m.mid?.length > 0 && !seenMids.current.has(m.mid))
            .map((m: ChartMessageItem) => {
                seenMids.current.add(m.mid);
                return { mid: m.mid, sender: m.sender };
            });

        if (mids.length > 0) {
            im.MsgRead(mids).catch(() => { });
        }
    });

    const JoinGroup = () => {
        if (isGroupTopic(curTid) && isAdmin && joinGroupUsers && joinGroupUsers.users && joinGroupUsers.users.length > 0) {
            return (
                <TouchableOpacity
                    activeOpacity={1}
                    onPress={() => navigation.navigate("JoinGroupScreen")}
                    style={{
                        borderRadius: 4,
                        marginTop: 4,
                        backgroundColor: white,
                        marginHorizontal: 10,
                        alignItems: "center",
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        flexDirection: "row",
                    }}
                >
                    <Image source={require("../../assets/image/icon_user.png")} />
                    <Text
                        style={{
                            color: color_333333,
                            fontSize: 16,
                            paddingVertical: 4,
                            marginHorizontal: 6,
                            flex: 1,
                        }}
                    >{`${Str_NewInvitationJoinGroup}（${joinGroupUsers?.users?.length || 0}）`}</Text>
                    <Image source={require("../../assets/image/icon_right_arrow.png")} />
                </TouchableOpacity>
            );
        } else {
            return <></>;
        }
    };

    const GroupNotice = () => {
        if (isGroupTopic(curTid) && groupNoticeRead !== "0" && groupNotice && groupNotice.length > 0) {
            return (
                <TouchableOpacity
                    activeOpacity={1}
                    onPress={() =>
                        navigation.navigate("GroupNotice", {
                            tid: curTid,
                            notice: groupNotice ?? "",
                            canEdit: isAdmin ?? false,
                        })
                    }
                    style={{
                        borderRadius: 4,
                        marginTop: 4,
                        backgroundColor: white,
                        marginHorizontal: 10,
                        alignItems: "center",
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        flexDirection: "row",
                    }}
                >
                    <Text
                        style={{
                            color: color_333333,
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "",
                            paddingVertical: 4,
                        }}
                    >
                        {Str_Notice}
                    </Text>
                    <Image style={{ marginStart: 4, width: 22, height: 22 }} source={require("../../assets/image/icon_group_notice.png")} />
                    <View style={{ flex: 1, marginStart: 10 }}>
                        <TextTicker
                            style={{ textAlign: "center", fontSize: 16, color: color_333333 }}
                            duration={groupNotice.length * 100}
                            useNativeDriver={Platform.OS !== 'web'}
                            marqueeDelay={1000.0}
                        >
                            {groupNotice}
                        </TextTicker>
                    </View>
                    <Image style={{ marginStart: 12 }} source={require("../../assets/image/icon_right_arrow.png")} />
                </TouchableOpacity>
            );
        } else {
            return <></>;
        }
    };
    const UnreadComponent = () => {
        if (!(data.unreadCnt > 10)) {
            return <></>;
        }
        return (
            <View
                style={{
                    marginTop: 4,
                    flexDirection: "row-reverse",
                }}
            >
                <Pressable
                    onPress={scrollToUnread}
                    style={{
                        backgroundColor: white,
                        height: 44,
                        width: "30%",
                        borderTopLeftRadius: 20,
                        borderBottomLeftRadius: 20,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        // iOS 阴影属性
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.25,
                        shadowRadius: 3.84,
                        // Android 阴影属性
                        elevation: 5,
                    }}
                >
                    <Image
                        style={{
                            width: 16,
                            height: 16,
                            objectFit: "contain",
                            marginBottom: 2,
                            marginEnd: 6,
                        }}
                        source={require("../../assets/image/icon_msg_top.png")}
                    />
                    <Text style={{ color: color_main, fontSize: 14 }}>
                        {data.unreadCnt}
                        {Str_NewMsgCount}
                    </Text>
                </Pressable>
            </View>
        );
    };

    // 重置所有的关于定位的属性都需要重置
    function resetAllMsgLocalVariable() {
        canRemoveToMsgRef.current = undefined;
        isNeedLocalAtTop.current = false;
        lastMsgWhileLical.current = undefined;
        nextPageMsgs.current = []
    }

    function onInputTypeChanged(type: ActiveIcon) {
        setBottomSafeAreaShow(type == 'emoji' ? true : false)

        if (isLastMsgNoShow) {
            // 点击了键盘, 那么所有的关于定位的属性都需要重置
            resetAllMsgLocalVariable()
            // 加载最新消息
            loadLastMsg(topicSummary)
            return
        }

        if (scrollOffsetRef.current > screenHeight && (messageListRef.current?.length ?? 0) >= 25) {
            // 数据太多,滑动太远的情况下, 对数据进行切片, 避免闪动
            const msgs: MessageSchema[] = messageListRef.current!.splice(0, 12)
            setMessage(msgs, 1);
            return
        }

        if (scrollOffsetRef.current >= 10) {
            scrollToFront(false, true)
        }
    }

    function onPress() {
        // Keyboard.dismiss()
        chatInputRef.current?.onTouch();
    }

    // 从某个消息开始拉取之后的消息- 消息定位
    function getHistoryMsgsFromMsg(msg: MessageSchema) {
        if (msg && msg.mid && msg.tid) {
            isLoad.current = true;
            loadLocalMsgsFromMsg(msg, [])
                .then((r) => {
                    if (r.length > 0) {
                        canRemoveToMsgRef.current = undefined
                        setMessage(r, 14);
                    } else {
                        isLoad.current = false;
                    }
                })
                .catch(() => {
                    isLoad.current = false;
                });
        }
    }

    function loadMoreLocalMsgs() {
        if (isBottomReached.current && !isLoad.current) {
            if (isLastMsgNoShow && messageListRef.current && messageListRef.current.length > 0) {
                // 标记新数据在加载中, 避免重复多次
                isLoad.current = true;
                let curMsgs = messageListRef.current
                // 从准备的数据中拉取
                if (nextPageMsgs.current.length) {
                    if (nextPageMsgs.current[0].mid == curMsgs[0].mid) {
                        // 切除这条消息后翻转
                        let newmsgs = nextPageMsgs.current.splice(1).reverse()
                        nextPageMsgs.current = []
                        if (canRemoveToMsgRef.current != undefined) {
                            // 删除可删除的那一页数据
                            newmsgs = newmsgs.filter((it) => {
                                return it.mid > canRemoveToMsgRef.current!.mid
                            })
                        } else {
                            if (newmsgs.length >= 50) {
                                // 已经加载了下一页,记录上一页是可删除到的位置
                                canRemoveToMsgRef.current = lastMsg.current
                            }
                        }

                        lastMsg.current = curMsgs[0]
                        newmsgs = [...newmsgs, ...curMsgs];
                        setMessage(newmsgs, 14);
                        return
                    } else {
                        // 如果走到这里, 说明数据错乱了,丢弃准备的数据
                        nextPageMsgs.current = []
                    }
                }

                // 从数据库拉取
                loadLocalMsgsFromMsg(messageList[0], messageListRef.current ?? messageList, false, 30)
                    .then((r) => {
                        if (r.length > 0) {
                            if (canRemoveToMsgRef.current != undefined) {
                                // 删除可删除的那一页数据
                                r = r.filter((it) => {
                                    return it.mid > canRemoveToMsgRef.current!.mid
                                })
                            } else {
                                if (r.length >= 50) {
                                    // 已经加载了下一页,记录上一页是可删除的
                                    canRemoveToMsgRef.current = lastMsg.current
                                }
                            }
                            setMessage(r, 14);

                        } else {
                            if ((topicSummary.topic.msg_synced ?? 0) !== 1) {
                                bridgeOnePageIfNeeded(curTid, false)
                                    .then(() => {
                                        loadLocalMsgsFromMsg(messageList[0], messageListRef.current ?? messageList, false, 30)
                                            .then((r2) => {
                                                if (r2.length > 0) {
                                                    if (canRemoveToMsgRef.current != undefined) {
                                                        r2 = r2.filter((it) => {
                                                            return it.mid > canRemoveToMsgRef.current!.mid
                                                        })
                                                    } else if (r2.length >= 50) {
                                                        canRemoveToMsgRef.current = lastMsg.current
                                                    }
                                                    setMessage(r2, 14);
                                                } else {
                                                    isBottomReached.current = false;
                                                    isLoad.current = false;
                                                }
                                            })
                                            .catch(() => {
                                                isBottomReached.current = false;
                                                isLoad.current = false;
                                            });
                                    })
                                    .catch(() => {
                                        isBottomReached.current = false;
                                        isLoad.current = false;
                                    });
                                return;
                            }
                            isBottomReached.current = false;
                            isLoad.current = false;
                        }
                    })
                    .catch(() => {
                        isBottomReached.current = false;
                        isLoad.current = false;
                    });
            } else {
                isBottomReached.current = false;
                isLoad.current = false;
                lastMsg.current = undefined
            }
        }
    }

    // 定位后,开始准备下一页的数据
    function prepareNextPageMsg(msg: MessageSchema) {
        if (msg && msg.mid && msg.tid && nextPageMsgs.current.length == 0) {
            // 加载更多消息, 从这条消息往后 30条,包括这条消息,为了之后拿这条消息做比对
            loadLocalMsgsFromMsg(msg, [], true, 15).then((r) => {
                if (r.length > 0) {
                    nextPageMsgs.current = r.reverse() // 翻转,把这条消息放在第一条
                }
            })
        }
    }

    const onScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
        scrollOffsetRef.current = event.nativeEvent.contentOffset.y;
        if (scrollOffsetRef.current === 0) {
            // 如果当前没有标识已经到达底部 并且 最新的消息没有展示
            if (!isBottomReached.current && isLastMsgNoShow) {
                // 标识到达底部 - 并加载更多消息
                isBottomReached.current = true;
                // 加载下一页的数据
                loadMoreLocalMsgs();
            }
        }
    };

    const viewabilityConfigRef = useRef({
        minimumViewTime: 300,
        viewAreaCoveragePercentThreshold: 80,
    });
    const callRTC = (isVideo: Boolean) => {
        RTCEngine.callRTC(topicSummary, isVideo);
    };

    function getMaintainVisibleContentPosition() {
        return isLastMsgNoShow ? { minIndexForVisible: 1 } : undefined
    }

    // 显示/隐藏侧边栏
    const toggleSidebar = useCallback((show: boolean) => {
        if (Platform.OS !== 'web') {
            return;
        }

        setIsSidebarVisible(show);
        Animated.timing(sidebarAnimation, {
            toValue: show ? 1 : 0,
            duration: 300,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: Platform.OS !== 'web',
        }).start();
    }, [Platform.OS, sidebarAnimation]);

    const handleRightClick = () => {
        if (Platform.OS === 'web') {
            // Web 环境：显示侧边栏
            toggleSidebar(true);
        } else {
            // 移动端：正常跳转
            navigation.navigate("ChatDetail");
        }
    };

    return (
        <SafeAreaView style={{ flex: 1, width: "100%", height: "100%", flexDirection: 'row' }}>
            {/* 主聊天区域 - 当侧边栏显示时，宽度缩小 */}
            <View
                style={{
                    flex: isSidebarVisible ? 1 : 1,
                    width: isSidebarVisible ? 'calc(100% - 400px)' : '100%',
                    transition: Platform.OS === 'web' ? 'width 0.3s ease-in-out' : undefined,
                    backgroundColor: white,
                }}
            >
                <NavBar
                    title={!isGroupTopic(curTid) ? data.titleName : `${data.titleName}（${topicSummary.users?.length || 0}）`}
                    showBack={false}
                    rightClick={handleRightClick}
                    rightChildren={<MoreIcon width={20} height={20} />}
                />
                {(memberSyncing || memberSyncError != null) ? (
                    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: white }}>
                        {memberSyncing ? (
                            <>
                                <ActivityIndicator size="large" color={color_main} />
                                <Text style={{ marginTop: 12, fontSize: 14, color: color_666666 }}>群成员数据加载中...</Text>
                            </>
                        ) : (
                            <>
                                <Text style={{ fontSize: 14, color: '#E53935', textAlign: 'center', paddingHorizontal: 32, marginBottom: 20 }}>{memberSyncError}</Text>
                                <Pressable
                                    style={{ paddingHorizontal: 32, paddingVertical: 10, backgroundColor: color_main, borderRadius: 20 }}
                                    onPress={() => syncGroupMembers(curTid)}
                                >
                                    <Text style={{ fontSize: 15, color: white }}>重试</Text>
                                </Pressable>
                            </>
                        )}
                    </View>
                ) : (
                <><JoinGroup />
                <GroupNotice />
                <View style={{ flex: 1 }}>
                    <FlatList
                        style={{ flex: 1, backgroundColor: ColorF5F5F5 }}
                        onTouchMove={onPress}
                        initialScrollIndex={0}
                        ref={flatListRef}
                        onScroll={onScroll}
                        onEndReached={() => {
                            if (isLoad.current === false) {
                                // 发送成功但是还没有tid
                                if (lastMsg.current === undefined || lastMsg.current?.send_statue === "0" || lastMsg.current?.send_statue === "1" || !(lastMsg.current?.tid && lastMsg.current?.mid)) {
                                    return;
                                }
                                getHistoryMsg();
                            }
                        }}
                        onEndReachedThreshold={0.5}
                        initialNumToRender={20} // 初始化要求渲染的条目
                        onViewableItemsChanged={onViewableItemsChangedRef.current}
                        keyboardDismissMode="on-drag"
                        keyExtractor={(item) => `${item.mid || item.cid}-${item.stime || Date.now()}-${item.type}-${item.sender}`}
                        inverted={true}
                        // decelerationRate={0.99} // 控制滚动速率
                        data={messageList}
                        contentContainerStyle={[chatStyles.flatList]}
                        maintainVisibleContentPosition={getMaintainVisibleContentPosition()}
                        onContentSizeChange={(_, height) => {
                            if (isNeedLocalAtTop.current && messageList.length) {
                                let msg = messageList[messageList.length - 1];
                                if (msg.type === MessageType.LOCAL_TIME && messageList.length >= 2) {
                                    msg = messageList[messageList.length - 2];
                                }

                                flatListRef.current?.scrollToItem({
                                    item: msg,
                                    animated: false,
                                    viewPosition: 0,
                                    viewOffset: 0
                                })
                                isNeedLocalAtTop.current = false;
                                // 拉取上一页的数据
                                getHistoryMsg();
                                return
                            }

                            // 记录最新内容高度
                            if (isLoad.current && isBottomReached.current && !isNeedLocalAtTop.current) {
                                flatListRef.current?.scrollToItem({
                                    item: lastMsg.current,
                                    animated: false,
                                    viewPosition: 1,
                                    viewOffset: 0
                                })
                                isBottomReached.current = false;
                                isLoad.current = false;

                            }
                        }}
                        renderItem={({ item, index }) => (
                            <View style={chatStyles.flatListRow}>
                                {data.talkSelectStatus && item.type !== MessageType.LOCAL_TIME && (
                                    <SelectDom isSelected={msgIsSelected(item)} onSelected={handleItemClick} item={item} disabled={true} />
                                )}
                                <ChatViewItemRender
                                    talkSelectStatus={data.talkSelectStatus}
                                    uid={currentUid}
                                    users={chatState.curTopicWithSummary?.users}
                                    handleChangeMask={handleChangeMask}
                                    onLongPressUserHead={onLongPressUserHead}
                                    handleQuote={handleQuote}
                                    handleQuoteLocal={handleQuoteLocal}
                                    handleDel={delMsg}
                                    submitMsg={handleSubmitMsg}
                                    submitMediaMsg={handleSubmitMedia}
                                    onClick={handleItemClick}
                                    item={item}
                                    group={group}
                                    isAdmin={isAdmin}
                                    toNavigation={() => setState({ ...data, talkSelectStatus: true })}
                                    handleRecall={(val) => setInputVal(val)} // 撤回重新编辑
                                />
                            </View>
                        )}
                    />
                    <View
                        style={{
                            position: "absolute",
                            start: 0,
                            end: 0,
                        }}
                    >
                        {/* <JinyanComponent /> */}
                        <UnreadComponent />
                    </View>
                </View>

                {data.talkSelectStatus ? (
                    <View style={chatStyles.tools}>
                        <ImageView
                            style={{ opacity: selectItems.length > 0 ? 1 : 0.3 }}
                            disabled={selectItems.length <= 0}
                            onClick={sendMessage}
                            source={require("../../assets/image/icon_chat_forward.png")}
                            imgStyle={chatStyles.toolsOk}
                        />

                        <ImageView
                            style={{ opacity: selectItems.length > 0 ? 1 : 0.3 }}
                            onClick={handleDelete}
                            disabled={selectItems.length <= 0}
                            source={require("../../assets/image/icon_chat_del.png")}
                            imgStyle={chatStyles.toolsOk}
                        />

                        <ImageView
                            onClick={() => {
                                dispatch({
                                    type: "UPDATE_SELECT_MESSAGE",
                                    payload: [],
                                });
                                setselectItems([]);

                                setState({ ...data, talkSelectStatus: false });
                            }}
                            source={require("../../assets/image/icon_chat_close.png")}
                            imgStyle={chatStyles.toolsOk}
                        />
                    </View>
                ) : (
                    <View style={{ overflow: "visible" }}>
                        <QuoteText
                            msg={quote}
                            currentUid={currentUid}
                            onClose={() => { setQuote(undefined); }}
                        />
                        <ChatInput
                            ref={chatInputRef}
                            from='ChatList'
                            topicId={curTid || ""}
                            isHadQuote={quote != undefined}
                            canSpeak={isBanned && canSpeak}
                            draft={topicSummary?.topic?.draft}
                            onInputTypeChanged={onInputTypeChanged}
                            onSubmit={handleSubmitMsg} // 文字/语音或/表情/自定义表情消息,单条- 不需要上传图片
                            onSubmitMedia={handleSubmitMedia} // 图片或视频消息,可能多条, 需要上传图片
                            type={topicSummary?.topic?.type === "group" ? ChatType.GROUP : ChatType.SINGLE}
                                // showCall={isGroupTopic(curTid) ? false : topicSummary.topic.uid === currentUid ? false : true}
                                showCall={false}
                            showImage={canSendImage}
                            showVideo={canSendVideo}
                            showFile={canSendFile}
                            onCallAudio={() => callRTC(false)}
                            onCallVideo={() => callRTC(true)}
                            inputVal={inputVal}
                            setInputVal={setInputVal}
                        />
                    </View>
                )}

                </>) }
            </View>

            {/* Web 环境下的侧边栏 - 不使用绝对定位，而是作为 flex 布局的一部分 */}
            {Platform.OS === 'web' && isSidebarVisible && (
                <Animated.View
                    style={{
                        width: 400,
                        backgroundColor: white,
                        shadowColor: '#000',
                        shadowOffset: { width: -2, height: 0 },
                        shadowOpacity: 0.25,
                        shadowRadius: 3.84,
                        elevation: 5,
                        transform: [
                            {
                                translateX: sidebarAnimation.interpolate({
                                    inputRange: [0, 1],
                                    outputRange: [400, 0], // 从右侧滑入
                                }),
                            },
                        ],
                        opacity: isSidebarVisible ? 1 : 0,
                    }}
                >
                    <SafeAreaView style={{ flex: 1, backgroundColor: white }}>
                        {/* 侧边栏内容 - 标题由内部组件管理 */}
                        <View style={{ flex: 1, overflow: 'hidden' }}>
                            <ChatDetail
                                navigation={navigation as any}
                                route={{ params: {} } as any}
                            />
                        </View>
                    </SafeAreaView>
                </Animated.View>
            )}

            {/* 图片预览模态框 */}
            <ImagePreviewModal
                visible={previewVisible}
                items={previewItems}
                initialIndex={initialPreviewIndex}
                onClose={() => setPreviewVisible(false)}
            />

        </SafeAreaView>
    );
};

const styles = StyleSheet.create({

})
